import type { User } from "./types/user.types";

export const userIsAdmin = (user: User | null | undefined): boolean => {
	if (user === undefined || user === null) {
		return false;
	}
	return user.isSuperAdmin;
};
